"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalTicketWorkflowQuery = exports.InternalTicketQuery = exports.InternalTicketUpdate = exports.InternalTicketCreate = exports.InternalTicketTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const enums_1 = require("./common/enums");
const tag_1 = require("./common/tag");
const visibility_1 = require("./common/visibility");
exports.InternalTicketTransport = typebox_1.Type.Recursive((Self) => typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    note: typebox_1.Type.String(),
    entityID: typebox_1.Type.String({ minLength: 1 }),
    entityType: enums_1.InternalTicketRelatedEntity,
    priority: typebox_1.Type.Optional(typebox_1.Type.Integer({ minimum: -2, maximum: 2 })),
    status: typebox_1.Type.Optional(enums_1.InternalTicketStatus),
    deletedAt: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    assignedToProfileID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    assignedTeam: typebox_1.Type.Optional(typebox_1.Type.String()),
    replyToID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    tags: typebox_1.Type.Array(tag_1.TagTransport),
    replies: typebox_1.Type.Array(Self),
    archivedDate: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    dueDate: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.String({ format: 'date-time' }))),
    images: typebox_1.Type.Array(common_1.S3ItemReference),
    visibility: typebox_1.Type.Array(visibility_1.VisibilityTransport),
    isPinned: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    followerIDs: typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' })),
    metadata: common_1.MetaData,
}), { $id: 'InternalTicketTransport' });
exports.InternalTicketCreate = typebox_1.Type.Intersect([
    typebox_1.Type.Object({
        note: typebox_1.Type.String(),
        entityID: typebox_1.Type.String({ minLength: 1 }),
        entityType: enums_1.InternalTicketRelatedEntity,
        tags: typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' })),
    }),
    typebox_1.Type.Partial(typebox_1.Type.Object({
        replyToID: typebox_1.Type.String({ format: 'uuid' }),
        // see InternalTicketPriorityLabel
        priority: typebox_1.Type.Integer({ minimum: -2, maximum: 2 }),
        status: enums_1.InternalTicketStatus,
        assignedToProfileID: typebox_1.Type.String({ format: 'uuid' }),
        assignedTeam: typebox_1.Type.String(),
        dueDate: (0, common_1.Nullable)(typebox_1.Type.String({ format: 'date-time' })),
        images: typebox_1.Type.Array(common_1.S3ItemReference),
        visibility: typebox_1.Type.Array(typebox_1.Type.String()),
        isPinned: typebox_1.Type.Boolean(),
        followerIDs: typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' })),
    })),
]);
exports.InternalTicketUpdate = typebox_1.Type.Partial(typebox_1.Type.Object({
    priority: (0, common_1.Nullable)(typebox_1.Type.Integer({ minimum: -2, maximum: 2 })),
    status: (0, common_1.Nullable)(enums_1.InternalTicketStatus),
    assignedTeam: (0, common_1.Nullable)(typebox_1.Type.String()),
    assignedToProfileID: (0, common_1.Nullable)(typebox_1.Type.String({ format: 'uuid' })),
    tags: typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' })),
    archivedDate: (0, common_1.Nullable)(typebox_1.Type.String({ format: 'date-time' })),
    dueDate: (0, common_1.Nullable)(typebox_1.Type.String({ format: 'date-time' })),
    images: typebox_1.Type.Array(common_1.S3ItemReference),
    visibility: typebox_1.Type.Array(typebox_1.Type.String()),
    isPinned: typebox_1.Type.Boolean(),
    followerIDs: typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' })),
}));
exports.InternalTicketQuery = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    common_1.BaseQuery,
    typebox_1.Type.Object({
        entityID: typebox_1.Type.String({ minLength: 1 }),
        entityType: typebox_1.Type.String({ minLength: 1 }),
        priority: typebox_1.Type.String({ minLength: 1 }),
        status: typebox_1.Type.Union([typebox_1.Type.Boolean(), typebox_1.Type.String({ minLength: 1 })]),
        assignedToProfileID: typebox_1.Type.String({ minLength: 1 }),
        /** Needs to be a comma separated list of team codes. Use [].join(',') */
        assignedTeam: typebox_1.Type.String({ minLength: 1 }),
        replyToID: typebox_1.Type.Union([typebox_1.Type.Boolean(), typebox_1.Type.String({ format: 'uuid' })]),
        tags: typebox_1.Type.String({ minLength: 1 }),
        createdBefore: typebox_1.Type.String({ format: 'date-time' }),
        createdAfter: typebox_1.Type.String({ format: 'date-time' }),
        dueDateBefore: typebox_1.Type.String({ format: 'date-time' }),
        dueDateAfter: typebox_1.Type.String({ format: 'date-time' }),
        includeDeleted: typebox_1.Type.Boolean(),
        createdByProfileID: typebox_1.Type.String({ format: 'uuid' }),
        followerIDs: typebox_1.Type.String({ minLength: 1 }),
        includeReplies: typebox_1.Type.Boolean(),
    }),
]));
exports.InternalTicketWorkflowQuery = typebox_1.Type.Object({
    OPEN: typebox_1.Type.Intersect([typebox_1.Type.Omit(exports.InternalTicketQuery, ['status']), typebox_1.Type.Object({ status: typebox_1.Type.Literal('OPEN') })]),
    IN_PROGRESS: typebox_1.Type.Intersect([
        typebox_1.Type.Omit(exports.InternalTicketQuery, ['status']),
        typebox_1.Type.Object({ status: typebox_1.Type.Literal('IN_PROGRESS') }),
    ]),
    SOLVED: typebox_1.Type.Intersect([typebox_1.Type.Omit(exports.InternalTicketQuery, ['status']), typebox_1.Type.Object({ status: typebox_1.Type.Literal('SOLVED') })]),
});
//# sourceMappingURL=internal-ticket.js.map